/*
Except the below locales, Traduki will return short locale.json files
   rewriteLocales:
      en-GB: en-GB
      en-US: en-US
      en-ZZ: en-ZZ
      pt-PT: pt-PT
      pt-BR: pt-BR
      zh-CN: zh-CN
      zh-TW: zh-TW
*/
// Enable this once Traduki starts returning short locale files
const getLocaleFileFromShortLocale = (locale: string): Record<string, string> | undefined => {
	switch (locale) {
		case 'cs':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/cs');
		case 'da':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/da');
		case 'de':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/de');
		case 'en':
		case 'en-us':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/en.json');
		case 'en-gb':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/en-GB');
		case 'es':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/es');
		case 'fi':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/fi');
		case 'fr':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/fr');
		case 'hr':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/hr');
		case 'hu':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/hu');
		case 'it':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/it');
		case 'ja':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/ja');
		case 'ko':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/ko');
		case 'nb':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/nb');
		case 'nl':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/nl');
		case 'pl':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/pl');
		case 'pt-br':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/pt-BR');
		case 'ru':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/ru');
		case 'sk':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@dev-agents/i18n/src/en.json');
		case 'sv':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/sv');
		case 'th':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/th');
		case 'tr':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/tr');
		case 'uk':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/uk');
		case 'vi':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/vi');
		case 'zh-cn':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/zh-CN');
		case 'zh-tw':
			// @ts-expect-error dynamic import somehow doesn't infer its type correctly
			return import('@atlassian/afm-i18n-dev-agents-dev-tooling/i18n/zh-TW');
		default:
			console.warn(
				`No translation file found for locale: ${locale}. Falling back to the default locale (en-US).`,
			);
			return undefined;
	}
};

// Parcel will import each case into a separate chunk, so it won't increase the bundle size with all languages included.
// Parcel can't dynamically import JSON files, so we use a switch statement to import the correct file based on the locale.
// TODO: please fix this with dynamic imports if you find a way to make it work with Parcel, since this solution could be fragile when translation language scales.
export const getMessagesForLocale = async (
	lowerCasedLocale: string,
): Promise<Record<string, string> | undefined> => {
	// This dynamic import approach doesn't work with Parcel, so we use a switch statement instead.
	// Please fix this if you find a way to make it work with Parcel, since this solution could be fragile when translation language scales.
	// try {
	// 	return await import(`./${lowerCasedLocale}.json`);
	// } catch (e1) {
	// 	console.warn(
	// 		`No translation file found for locale file: ${lowerCasedLocale}.json. Falling back to rule-based imports.`,
	// 	);
	// }

	return getLocaleFileFromShortLocale(lowerCasedLocale);
};
